const DEFAULT_CONFIG_DATA_TABLE_OPTIONS = {
  selectableRows: "multiple",
  filter: false,
  print: false,
  viewColumns: false,
  download: false,
  elevation: 2,
  rowsPerPage: 20,
  rowsPerPageOptions: [20, 50, 100]
};
export const createTableOptions = (entityName, recordLength) => {
  const options = {
    ...DEFAULT_CONFIG_DATA_TABLE_OPTIONS
  };
  options.pagination = recordLength > 20;
  options.textLabels = {
    body: {
      noMatch: `No ${entityName} records found`
    },
    selectedRows: {
      text: `${entityName}(s) selected`,
      delete: `Remove ${entityName}(s)`,
      deleteAria: `Delete selected ${entityName}`
    }
  };
  return options;
};